/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Self-hosted fonts (Fraunces = display, Source Serif 4 + Tiro Devanagari Hindi = bilingual body)
import '@fontsource-variable/fraunces'
import '@fontsource-variable/source-serif-4/opsz.css'
import '@fontsource-variable/source-serif-4/opsz-italic.css'
import '@fontsource/tiro-devanagari-hindi/400.css'
import '@fontsource/tiro-devanagari-hindi/400-italic.css'

import React from 'react'
import { LanguageProvider } from './src/lib/language'
import { PersonalProvider } from './src/context/PersonalContext'

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    <PersonalProvider>{element}</PersonalProvider>
  </LanguageProvider>
)
